<template>
	<div class="full-pleca-iconos">
		<div class="contenedor-headerImageShort">
			<h2>What you need to know for...</h2>
			<div class="contenido">
				<div class="modulo modulo-1">
					<b-link @click="showModal('What_Residential')" >
						<img  class="icono1" src="~Img/baseline-home-24px.svg" alt="Residential Construction" />
					</b-link>
					<div class="botones-modulo">
						<ul>
							<li> <b-link @click="showModal('What_Residential')" > <span>New Residential Construction</span></b-link> </li>
							<!-- <li><b-link v-b-modal.modalFull @click="setProp('a')"><span>Upload Files</span></b-link></li> -->
						</ul>
					</div>
				</div>
				<div class="modulo modulo-2">
					<b-link @click="showModal('What_Additions')" >
						<img class="icono2" src="~Img/baseline-home2-24px.svg" alt="Residential Additions"/>
					</b-link>
					<div class="botones-modulo">
						<ul>
							<li><b-link @click="showModal('What_Additions')" ><span>Residential Addition Construction</span></b-link></li>
							<!-- <li><b-link v-b-modal.modalFull @click="setProp('b')"><span>Upload Files</span></b-link></li> -->
						</ul>
					</div>
				</div>
				<div class="modulo modulo-3">
					<b-link @click="showModal('What_NonResidential')" >
						<img class="icono3" src="~Img/baseline-location_city-24px.svg" alt="Non-Residential Construction">
					</b-link>
					<div class="botones-modulo">
						<ul>
							<li><b-link @click="showModal('What_NonResidential')" ><span>Commercial or Non-Residential <br > Construction</span></b-link></li>
							<!-- <li><b-link v-b-modal.modalFull @click="setProp('c')" ><span>Upload Files</span></b-link></li> -->
						</ul>
					</div>
				</div>
			</div> <!-- end contenido -->
			<!-- <h2 style="margin-top: 10px; margin-bottom: 10px">Call us at 415-259-4068 to get started</h2> -->

			<!-- Modal What do you need - start -->
			<b-modal id="modal1" ref="myModalRef" hide-footer size="lg" :title="TitlePop">

				<div v-if="PopState==='What_Residential'"> <what-Do-You-Need-Residential /> </div>
				<!-- <div v-if="PopState==='Trans_Residential'"> <transmittal-Residential /> </div> -->
				<div v-if="PopState==='What_Additions'"> <what-Do-You-Need-Additions /> </div>
				<!-- <div v-if="PopState==='Trans_Additions'"> <transmittal-Additions /> </div> -->
				<div v-if="PopState==='What_NonResidential'"> <what-Do-You-Need-Non-Residential /> </div>
				<!-- <div v-if="PopState==='Trans_NonResidential'"> <transmittal-Non-Residential />  </div> -->

				<div style="width: 100%; display: flex; justify-content:center;">
					<a @click="hideModal" >
						<easyBtn  btnText="Close" />
					</a>
				</div>
			</b-modal>

			<b-modal id="modalFull"  size="sm" centered hide-footer title="Upload your files ">
				<popUpUpload uploadType='all' />
			</b-modal>

			<b-modal id="modal-center" size="md" hide-footer v-model="isOpenModal" centered title="">
				<div class="what-content">
					<div class="header-image sended">
						<div class="modul-1">
							<h3>Your files have been sent.</h3>
						</div>
					</div>

					<div class="modal-files-sended ">
						<p>
							Thank you for uploading your project files. You should receive an email confirming the upload of your project.
						</p>
						<p>
							If you do not hear back from us in the next couple of days, please send an email to <a class="contextual-link" :href="`mailto:${navLinks.customerMail}`"> {{ navLinks.customerMail }} </a> or contact us at <span class="contextual-label"> {{ navLinks.supportPhone1 }} </span> or at <span class="contextual-label"> {{ navLinks.supportPhone2 }} </span>
						</p>
					</div>
				</div>

				<div style="width: 100%; display: flex; justify-content:center;" >
					<a @click="isOpenModal = false">
						<easyBtn  btnText="Close" />
					</a>
				</div>
			</b-modal>
		</div>
  </div>
</template>
<script>

import bus from '@/commonSite/eventBus.js'
import whatDoYouNeedResidential from '@/components/full/pops/residential/whatResidential'
// import transmittalResidential from '@/components/full/pops/residential/transmittalResidential'

import whatDoYouNeedAdditions from '@/components/full/pops/additions/whatAdditions'
// import transmittalAdditions from '@/components/full/pops/additions/transmittalAdditions'

import whatDoYouNeedNonResidential from '@/components/full/pops/nonResidential/whatNonResidential'
// import transmittalNonResidential from '@/components/full/pops/nonResidential/transmittalNonResidential'

import popUpUpload from '@/commonSite/uploadFiles'
import easyBtn from 'Common/components/easy-btn.vue'
export default {
	name: 'iconBar',
	data () {
		return {
			PopState: '',
			TitlePop: 'Title Pop Up',
			selected: null,
			text1: '',
			text2: '',
			text3: '',
			text4: '',
			text: '',
			getProp: 'a',
			isOpenModal: false,
			navLinks: {}
		}
	},
	components: {
		whatDoYouNeedResidential,
		// transmittalResidential,
		whatDoYouNeedAdditions,
		// transmittalAdditions,
		whatDoYouNeedNonResidential,
		// transmittalNonResidential,
		popUpUpload,
		easyBtn
	},
	created () {
		bus.$on('files-sended', isOpen => {
			this.isOpenModal = isOpen
		})
		// this.isOpenModal = true
	},
	beforeMount: function () {
		this.navLinks = this.$e24Common.storageService.findItem('navLinks', true)
		// console.debug(`navLinks is `, this.navLinks)
	},
	methods: {
		showModal (estado) {
			this.PopState = estado
			this.$refs.myModalRef.show()
			this.changeTitle()
		},
		hideModal () {
			this.PopState = ''
			this.$refs.myModalRef.hide()
			console.log('the modal is close now')
		},
		changeTitle () {
			switch (this.PopState[0]) {
			case 'W':
				this.TitlePop = ''
				break
			case 'T':
				this.TitlePop = 'Transmittal Form'
				break
			default:
				break
			}
		},
		setProp (value) {
			this.getProp = value
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/full/iconsBar.vue